import { useHistory } from 'react-router';
import { useCallback } from 'react';

import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { Button } from 'UIPackage/MainModule/components/Button';
import { ROUTE_ADMIN_NEWS } from 'CorePackage/MainModule/routes/routes';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';

import { mapNewsType } from '../common/mapNewsType';
import styles from './Modal.module.scss';
import { INewsForm } from '../interfaces/INewsForm';

interface ICancelModalProps {
  visible: boolean;
  values: INewsForm;
  onClose: () => void;
}

export const CancelModal = ({ values, visible, onClose }: ICancelModalProps) => {
  const history = useHistory();

  const onConfirmModal = useCallback(() => {
    history.push(ROUTE_ADMIN_NEWS);
  }, [history]);

  return (
    <Modal visible={visible} modalBodyClassName={styles.Modal} onClose={onClose}>
      <ModalHeader title={values.type?.id && mapNewsType(values.type.id)} />
      <ModalBody size="content" border="bottom">
        <div className={styles.Body}>Желаете выйти без сохранения изменений?</div>
      </ModalBody>
      <ModalActions>
        <Button color="primary" size="medium" text="Да" onClick={onConfirmModal} />
        <Button color="default" size="medium" text="Нет" type="button" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
